import { InventoryTree } from '@scaleaq/sitecontrol-lib';
import { useTranslation } from 'react-i18next';

import { Generator } from '@/components/generators/Generator.tsx';
import { useGetGenerators } from '@/components/generators/useGetGenerators.ts';
import { GridWidget } from '@/components/GridWidget.tsx';
import { ComponentType, GenericWidgetProps, WidgetHealthIssue } from '@/types.ts';
import { GLOBAL_GENERATOR_COMPONENT_NAME } from '@/widgetComponentNames.ts';

export const GlobalGenerator: ComponentType<InventoryTree & GenericWidgetProps> = ({
  id,
  name,
  ...rest
}: InventoryTree & GenericWidgetProps) => {
  const { t } = useTranslation(['common']);
  const { generators, isLoading } = useGetGenerators();
  const selectedGenerator = generators ? Object.values(generators).find(g => g.id === id) : null;

  if (isLoading) {
    return <GridWidget {...rest} headerTitle={name} isLoading />;
  }

  if (!selectedGenerator) {
    const loadErrorHealthIssues: WidgetHealthIssue[] = [
      { severity: 'error', message: t('errorMessage') },
    ];
    return (
      <GridWidget
        {...rest}
        headerTitle={name}
        isError
        errorMessage={t('errorMessage')}
        healthIssues={loadErrorHealthIssues}
      />
    );
  }
  return <Generator generator={selectedGenerator} {...rest} />;
};

GlobalGenerator.componentName = GLOBAL_GENERATOR_COMPONENT_NAME;
